"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _AssetActivityDetails = _interopRequireDefault(require("../../components/AssetActivityDetails"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _MarginClosePositionModal = _interopRequireDefault(require("../../components/MarginClosePosition/MarginClosePositionModal"));
var _positionActions = require("../../redux/actions/positionActions");
var _marginSelectors = require("../../redux/margin/selectors/marginSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var classes = (0, _cssClassesHelper.getBEMClasses)('asset-activity-details-layout');
var BuySellDesktopLayout = function BuySellDesktopLayout(_ref) {
  var MarginBorrowerEnabled = _ref.MarginBorrowerEnabled,
    selectPositionAndSave = _ref.selectPositionAndSave;
  (0, _react.useEffect)(function () {
    selectPositionAndSave(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes('content-wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_AssetActivityDetails["default"], null)), MarginBorrowerEnabled && /*#__PURE__*/_react["default"].createElement(_MarginClosePositionModal["default"], null));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    MarginBorrowerEnabled: (0, _marginSelectors.marginBorrowerEnabledSelector)(state)
  };
};
var mapDispatchToProps = {
  selectPositionAndSave: _positionActions.selectPositionAndSave
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BuySellDesktopLayout);